/**
 * Efeito sonoro dos alertas (alarme novo / usina off-line).
 *
 * Usa a Web Audio API para gerar o som, evitando depender de um arquivo de
 * áudio no bundle. Navegadores bloqueiam áudio antes da primeira interação do
 * usuário com a página; nesse caso o play falha silenciosamente.
 */

let audioContext: AudioContext | null = null;

const getAudioContext = (): AudioContext | null => {
  try {
    const AudioContextClass =
      (window as any).AudioContext || (window as any).webkitAudioContext;

    if (!AudioContextClass) return null;

    if (!audioContext) {
      audioContext = new AudioContextClass();
    }

    return audioContext;
  } catch (error) {
    return null;
  }
};

const playTone = (
  context: AudioContext,
  frequency: number,
  startAt: number,
  duration: number,
  volume: number
) => {
  const oscillator = context.createOscillator();
  const gain = context.createGain();

  oscillator.type = 'sine';
  oscillator.frequency.setValueAtTime(frequency, startAt);

  gain.gain.setValueAtTime(0.0001, startAt);
  gain.gain.exponentialRampToValueAtTime(volume, startAt + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);

  oscillator.connect(gain);
  gain.connect(context.destination);

  oscillator.start(startAt);
  oscillator.stop(startAt + duration + 0.02);
};

/**
 * Toca o som de alerta. `type` muda levemente o timbre:
 * OFFLINE = duas notas descendentes, ALARME = duas notas ascendentes,
 * VERIFICATION_CODE = três notas curtas ascendentes.
 */
export const playAlertSound = (type?: string) => {
  try {
    const context = getAudioContext();
    if (!context) return;

    if (context.state === 'suspended') {
      context.resume().catch(() => {});
    }

    const now = context.currentTime;

    if (type === 'OFFLINE') {
      playTone(context, 660, now, 0.18, 0.12);
      playTone(context, 440, now + 0.2, 0.28, 0.12);
    } else if (type === 'VERIFICATION_CODE') {
      playTone(context, 784, now, 0.1, 0.1);
      playTone(context, 988, now + 0.12, 0.1, 0.1);
      playTone(context, 1318, now + 0.24, 0.22, 0.1);
    } else {
      playTone(context, 880, now, 0.16, 0.1);
      playTone(context, 1174, now + 0.18, 0.26, 0.1);
    }
  } catch (error) {
    // som é acessório: nunca deve quebrar o fluxo do alerta
  }
};

export default playAlertSound;
